export default "__VITE_ASSET___T7Wvrai__"